// User-Agent Client Hints, Chromium only; not yet in TS DOM lib
type NavigatorWithUAData = Navigator & { userAgentData?: { mobile: boolean } };

// Phones only: Android tablets omit "Mobile" from their UA, iPads report as iPad or desktop Mac.
export const isMobilePhone = (): boolean => {
  const { userAgentData } = navigator as NavigatorWithUAData;

  if (userAgentData) {
    return userAgentData.mobile;
  }

  return /Android.+Mobile|iPhone|iPod|Windows Phone|IEMobile|BlackBerry|Opera Mini/i.test(
    navigator.userAgent
  );
};
